export const HAS_QUANTITY = 1

export const NO_PRODUCT_CODE = 'No ProductCode'

export const PER_PAGE_ALL = 1000

export const PAGE_SIZE = {
  SMALL: 5,
  MEDIUM: 10,
  LARGE: 20
}

export const TAX_OPTIONS = [
  { value: 0, label: '0%' },
  { value: 8, label: '8%' },
  { value: 10, label: '10%' }
]

export const SHIPPING_METHOD = [
  { value: 'FEDEX', label: 'FedEx' },
  { value: 'AIR_FREIGHT', label: 'Air Freight' },
  { value: 'OCEAN_FREIGHT', label: 'Ocean Freight' }
]

export const SHIPPING_TERMS = [
  { value: 'EXW', label: 'EXW' },
  { value: 'EX-GODOWN', label: 'EX-GODOWN' }
]

export const DEFAULT_PAGINATION_PARAMS = {
  page: 1,
  per_page: PAGE_SIZE.MEDIUM
}

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  USER_INFO: 'app-store'
} as const

export const DEVICE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
  OTHER: 'other'
} as const

export type Device = (typeof DEVICE)[keyof typeof DEVICE]

export const ROLES = {
  DISTRIBUTOR_ADMIN: 'admin',
  DELIVERY_STAFF: 'delivery',
  CUSTOMER_ADMIN: 'manager',
  CUSTOMER_STAFF: 'user',
  SYSTEM: 'system'
} as const

export type UserRole = (typeof ROLES)[keyof typeof ROLES]
